/**
 * Metric type utilities
 *
 * Functions for working with metric data types and their properties.
 */

/**
 * Determine filter type based on data type
 */
export function getFilterType(dataType: string): "text" | "number" | "date" {
  switch (dataType) {
    case "integer":
    case "float":
    case "currency":
      return "number";
    case "date":
      return "date";
    default:
      return "text";
  }
}

/**
 * Map various metric type representations to formula-compatible data types
 */
export function mapMetricTypeToFormulaType(
  metricType: string | undefined,
): "number" | "string" | "date" | "boolean" | "currency" {
  if (!metricType) return "number";

  const normalizedType = metricType.toLowerCase();

  switch (normalizedType) {
    case "currency":
      return "currency";
    case "date":
    case "datetime":
      return "date";
    case "boolean":
      return "boolean";
    case "string":
    case "text":
      return "string";
    // Numeric types - explicitly listed for documentation
    // biome-ignore-start lint/complexity/noUselessSwitchCase: documenting known metric types
    case "number":
    case "integer":
    case "float":
    case "percentage":
    case "days":
    // biome-ignore-end lint/complexity/noUselessSwitchCase: documenting known metric types
    default:
      return "number";
  }
}

/**
 * Legacy mapping object for backward compatibility
 */
export const METRIC_TYPE_MAP: Record<string, string> = {
  integer: "number",
  float: "number",
  currency: "currency",
  date: "date",
  datetime: "date",
  number: "number",
  boolean: "boolean",
  string: "string",
  text: "string",
  percentage: "number",
  days: "number",
};
